(function(){
  const API = {
    cart: '/cart.js',
    add: '/cart/add.js',
    reco: (id, limit) => `/recommendations/products.json?product_id=${id}&intent=complementary&limit=${limit||4}`,
    coll: (handle, limit) => `/collections/${handle}/products.json?limit=${limit||50}`
  };

  function formatMoney(cents){
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency: (window.Shopify?.currency?.active || document.documentElement.dataset.currency || 'PLN')}).format(cents/100); }
    catch(e){ return (cents/100).toFixed(2) + ' zł'; }
  }
// pełna normalizacja PL → ASCII
function normalizeText(s){
  return (s || '')
    .replace(/[Ąą]/g,'a')
    .replace(/[Ćć]/g,'c')
    .replace(/[Ęę]/g,'e')
    .replace(/[Łł]/g,'l') 
    .replace(/[Ńń]/g,'n')
    .replace(/[Óó]/g,'o')
    .replace(/[Śś]/g,'s')
    .replace(/[ŹźŻż]/g,'z')
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .toLowerCase();
}

function hasToken(text, tokens){
  const t = normalizeText(text);
  const SEP = `(?:^|\\s|[\\-_/|()\\[\\],.;:])`;
  return tokens.some(tok => {
    const re = new RegExp(`${SEP}${tok}${SEP}`, 'i');
    return re.test(` ${t} `);
  });
}

function titleCategory(title){
  const CHAINS = ['lancuch','lancuchy','lancuszek','naszyjnik','necklace','chain'];
  const BRACE  = ['bransoletka','bransoletki','bransoleta','bracelet'];
  const PENDS  = ['zawieszka','zawieszki','przywieszka','pendant','medalik','charms'];
  if (hasToken(title, CHAINS)) return 'chain';
  if (hasToken(title, BRACE))  return 'bracelet';
  if (hasToken(title, PENDS))  return 'pendant';
  return null;
}


  async function getCart(){
    const r = await fetch(API.cart,{credentials:'same-origin'}); if(!r.ok) throw new Error('Cart fetch error'); return r.json();
  }
  async function getReco(pid, limit){
    const r = await fetch(API.reco(pid, limit),{credentials:'same-origin'}); if(!r.ok) return { products: [] }; return r.json();
  }
  async function getCollectionProducts(handle, limitPerCollection){
    const r = await fetch(API.coll(handle, limitPerCollection), { credentials:'same-origin' });
    if(!r.ok) return [];
    const data = await r.json();
    return Array.isArray(data?.products) ? data.products : [];
  }

  function getPriceCents(p){
  // priorytet: price -> price_min -> variants[0].price
  let val = p?.price ?? p?.price_min ?? (p?.variants && p.variants[0]?.price);
  if (val == null) return null;

  // może być string "139.00" albo liczba w groszach/centach
  if (typeof val === 'string') {
    // zamień "139.00" na grosze
    const n = parseFloat(val.replace(',', '.'));
    if (Number.isFinite(n)) return Math.round(n * 100);
  }
  if (typeof val === 'number') {
    // jeżeli wygląda na złotówki (np. 139.00), przelicz na grosze
    if (val < 1000 && String(val).includes('.')) return Math.round(val * 100);
    return Math.round(val);
  }
  return null;
}

function getPriceCents(p){
  let val = p?.price ?? p?.price_min ?? (p?.variants && p.variants[0]?.price);
  if (val == null) return null;
  if (typeof val === 'string') { const n = parseFloat(val.replace(',', '.')); if (Number.isFinite(n)) return Math.round(n * 100); }
  if (typeof val === 'number') { if (val < 1000 && String(val).includes('.')) return Math.round(val * 100); return Math.round(val); }
  return null;
}

function buildCard(p){
  const img =
    p?.images?.[0]?.src ||
    p?.featured_image ||
    p?.image?.src ||
    p?.images?.[0] || null;

  const priceCents = getPriceCents(p);
  const price = priceCents != null ? formatMoney(priceCents) : '';
  const url = p?.url || (p?.handle ? `/products/${p.handle}` : '#');

  // TYLKO „Zobacz”
  const linkBtn = `<a class="metini-card__btn metini-card__btn--link" href="${url}">${document.documentElement.lang.toLowerCase().startsWith('pl') ? 'Zobacz' : 'View'}</a>`;

  return `
    <article class="metini-card" data-product-id="${p.id || ''}">
      <div class="metini-card__media">
        ${img ? `<img src="${img}" alt="${(p.title||'').replace(/"/g,'&quot;')}">` : ''}
      </div>
      <div>
        <h4 class="metini-card__title">${p.title || ''}</h4>
        <div class="metini-card__price">${price}</div>
        <div class="metini-card__row">${linkBtn}</div>
      </div>
    </article>
  `;
}



  async function addToCart(variantId){
    const fd = new FormData(); fd.append('id', variantId); fd.append('quantity', '1');
    const r = await fetch(API.add, { method:'POST', body: fd, credentials:'same-origin' });
    if(!r.ok) throw new Error('Add to cart failed'); return r.json();
  }

  async function refreshDrawerLikeTheme(){
    try{
      const res = await fetch(`${routes.cart_url}?section_id=cart-drawer`, { credentials:'same-origin' });
      if(!res.ok) throw new Error('Section fetch failed');
      const htmlText = await res.text();
      const doc = new DOMParser().parseFromString(htmlText, 'text/html');
      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
      for(const sel of selectors){
        const target = document.querySelector(sel);
        const source = doc.querySelector(sel);
        if(target && source) target.replaceWith(source);
      }
      document.dispatchEvent(new CustomEvent('metini:cart-drawer-updated', { detail: { root: document } }));
      window.MetiniComplementary && window.MetiniComplementary.init();
    }catch(err){ console.warn('[Metini Complementary] refresh error', err); }
  }

  // --- helpers: czy produkt to łańcuch/bransoletka (po tagach/type) ---
  function isChain(tags, type){
    const t=(type||'').toLowerCase(); const g=(tags||[]).join(',').toLowerCase();
    return g.includes('cat:chain') || t.includes('chain') || t.includes('łańcuch') || t.includes('lancuch');
  }
  function isBracelet(tags, type){
    const t=(type||'').toLowerCase(); const g=(tags||[]).join(',').toLowerCase();
    return g.includes('cat:bracelet') || t.includes('bracelet') || t.includes('bransolet');
  }

  // --- odczyt mapy zawieszek z DOM (z Liquid) ---
  function readPendantCollectionsMap(){
    const map = [];
    document.querySelectorAll('.metini-pendants-map').forEach(el=>{
      const pid = parseInt(el.getAttribute('data-product-id'),10);
      try{
        const cols = JSON.parse(el.getAttribute('data-collections') || '[]').filter(Boolean);
        if(pid && cols.length) map.push({ product_id: pid, handles: cols });
      }catch(_e){}
    });
    return map;
  }

  async function render(){
    const box = document.getElementById('metini-complementary');
    if(!box) return;

    const track      = box.querySelector('.metini-comp__track');
    const limitReco  = parseInt(box.getAttribute('data-limit') || '4', 10);
    const limitPends = parseInt(box.getAttribute('data-limit-pendants') || '4', 10);

    let cart;
    try{ cart = await getCart(); } catch(e){ box.classList.add('hidden'); return; }
    if(!cart?.items?.length){ box.classList.add('hidden'); return; }

const cartCats = new Set();
for (const line of cart.items){
  const t = line.product_title || line.title || line.product?.title || '';
  const cat = titleCategory(t);
  if (cat) cartCats.add(cat);
}


    const inCartIds = new Set(cart.items.map(i => i.product_id));

    // 1) S&D complementary – wybierz pierwszy sensowny produkt z koszyka
    let reco = { products: [] };
    let context = null; // 'chain' | 'bracelet'
    for (const line of cart.items){
      const t = line.product_type || line.product?.product_type || '';
      const tags = line.product_tags || line.product?.tags || [];
      if (isChain(tags, t)){ context = 'chain'; }
      else if (isBracelet(tags, t)){ context = 'bracelet'; }
      // próbujemy rekomendacji S&D dla tej pozycji:
      try{
        const r = await getReco(line.product_id, limitReco + 6);
      const cleaned = (r.products || [])
        .filter(p => !inCartIds.has(p.id))
        .filter(p => {
          const c = titleCategory(p.title || '');
          return !c || !cartCats.has(c); 
        });
        if(cleaned.length){
          reco.products = cleaned.slice(0, limitReco);
          if (!context) context = 'chain'; // fallback
          break;
        }
      }catch(_e){}
    }

    // 2) Zawieszki z metafieldu (jeśli w koszyku jest łańcuch i mamy mapę)
    const pendMap = readPendantCollectionsMap();
    let pendants = [];
    if ((context === 'chain' || pendMap.length) && limitPends > 0 && !cartCats.has('pendant')) {

      // weź pierwszą mapę (pierwszy łańcuch w koszyku, który ma kolekcje)
      const firstWithMap = cart.items.find(li => pendMap.some(m => m.product_id === li.product_id));
      if (firstWithMap){
        const m = pendMap.find(x => x.product_id === firstWithMap.product_id);
        if (m && m.handles && m.handles.length){
          for (const h of m.handles){
            if (pendants.length >= limitPends) break;
            try{
              const prods = await getCollectionProducts(h, 50);
            for (const p of prods){
              if (pendants.length >= limitPends) break;
              if (inCartIds.has(p.id)) continue;
              if (reco.products.some(x => x.id === p.id)) continue;
              const c = titleCategory(p.title || '');
              if (c && cartCats.has(c)) continue; 
              pendants.push(p);
            }

            }catch(_e){}
          }
        }
      }
    }

const finalList = [...(reco.products||[]), ...(pendants||[])];

// globalny filtr: nie pokazuj kategorii już obecnych w koszyku
const filteredList = finalList.filter(p => {
  const c = titleCategory(p.title || '');
  return !c || !cartCats.has(c);
});

track.innerHTML = '';
if(!filteredList.length){ box.classList.add('hidden'); return; }

track.innerHTML = filteredList.map(buildCard).join('');
box.classList.remove('hidden');


    // iOS single-tap fix na link "Zobacz"
    let tX=0, tY=0, moved=false, t0=0; const TAP_DIST=6, TAP_TIME=350;
    track.addEventListener('touchstart', (ev)=>{const t=ev.touches&&ev.touches[0]; if(!t)return; tX=t.clientX;tY=t.clientY;moved=false;t0=Date.now();},{passive:true});
    track.addEventListener('touchmove', (ev)=>{const t=ev.touches&&ev.touches[0]; if(!t)return; if(Math.abs(t.clientX-tX)>TAP_DIST||Math.abs(t.clientY-tY)>TAP_DIST)moved=true;},{passive:true});
    track.addEventListener('touchend', (ev)=>{const dt=Date.now()-t0; if(!moved&&dt<TAP_TIME){const a=ev.target.closest('a.metini-card__btn--link'); if(a){ev.preventDefault(); window.location.assign(a.href);}}});
  }

  // Stabilizacja: MutationObserver + idempotentny init
  let _moStarted = false, _mo;
  function startObserver() {
    if (_moStarted) return;
    const root = document.getElementById('CartDrawer') || document.querySelector('.cart-drawer__footer') || document.body;
    if (!root) return;
    let t; const safeRender = () => { clearTimeout(t); t = setTimeout(render, 20); };
    _mo = new MutationObserver(safeRender);
    _mo.observe(root, { childList: true, subtree: true });
    _moStarted = true;
  }

  window.MetiniComplementary = { init(){ startObserver(); render(); } };
  document.addEventListener('DOMContentLoaded',     () => { window.MetiniComplementary.init(); });
  document.addEventListener('metini:cart-drawer-updated', () => { window.MetiniComplementary.init(); });
  document.addEventListener('shopify:section:load', () => { window.MetiniComplementary.init(); });
})();
